import { ArrowRight } from "lucide-react";

const toneStyles = {
  tofu: "bg-[#F5F5FF] ring-1 ring-[#6366F140]/25",
  mofu: "bg-[#FAF5FF] ring-1 ring-[#A78BFA40]/25",
  bofu: "bg-[#F0FDF4] ring-1 ring-[#22C55E40]/25",
  hso: "bg-[#FEF3C7] ring-1 ring-[#FDE68A] text-[#B45309]",
  pas: "bg-[#FFEDD5] ring-1 ring-[#FED7AA] text-[#C2410C] ",
};
const badgeTone = {
  tofu: "bg-[#6366F11A]/10  text-[#6366F1]",
  mofu: "bg-[#A78BFA1A]/10  text-[#7C3AED]",
  bofu: "bg-[#22C55E1A]  text-[#16A34A]",
};

export default function FeaturePreview({ preview }) {
  /* ---- ad-composer form ---- */
  if (preview.type === "form") {
    return (
      <div className="rounded-[18px] bg-white ring-1 ring-black/[0.06] shadow-[0_24px_48px_-24px_rgba(16,24,40,0.25)] p-5 2xl:p-6">
        <div className="space-y-4">
          {preview.fields.map((f) => (
            <div key={f.label}>
              <div className="flex items-center justify-between mb-1.5">
                <span className=" text-[9px]  md:text-[10px] font-semibold uppercase tracking-[0.06em] text-[#A8A29E]">
                  {f.label}
                </span>
                {f.count && (
                  <span
                    className={`text-[9px] md:text-[10px] font-semibold ${
                      f.overLimit ? "text-[#F59E0B]" : "text-[#C4C0BB]"
                    }`}
                  >
                    {f.count}
                  </span>
                )}
              </div>
              <div
                className={`rounded-[8px] px-3.5 py-2.5 text-[12px] md:text-[13px] leading-[1.45] text-[#292929] ring-1 ${
                  f.overLimit
                    ? "bg-[#FFFBEB] ring-[#F59E0B66]"
                    : "bg-[#FAFAF9] ring-[#E7E5E4]"
                }`}
              >
                {f.text}
              </div>
            </div>
          ))}
        </div>
        <a
          href={preview?.href}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 group w-full flex items-center justify-center gap-1 rounded-[8px] bg-gradient-to-r from-[#3232AA] to-[#141444] py-3 text-[11px] sm:text-[12px] lg:text-[14px] font-semibold text-white"
        >
          {preview.button}
          <ArrowRight
            size={16}
            className=" group-hover:translate-x-1 transition-transform duration-300 "
          />
        </a>
      </div>
    );
  }

  /* ---- scroll-hook list ---- */
  if (preview.type === "list") {
    return (
      <div className="rounded-[18px] bg-white ring-1 ring-black/[0.06] shadow-[0_24px_48px_-24px_rgba(16,24,40,0.25)] p-5 2xl:p-6">
        <div className="flex items-center gap-2 mb-4">
          <span className="h-2 w-2 rounded-full bg-[#22C55E]" />
          <span className="  lg:text-[13px] font-semibold text-[#283245]">
            {preview.title}
          </span>
        </div>
        <div className="space-y-4">
          {preview.items.map((item) => (
            <div key={item.label} className="first:pt-0">
              <span className="text-[10px] lg:text-[11px] font-semibold uppercase tracking-[0.06em] text-[#A8A29E]">
                {item.label}
              </span>
              <div className="flex mt-1 justify-center gap-3 ">
                <span className="w-[2.7px] shrink-0 bg-[#6366F166]/40" />
                <p className=" text-[12px] lg:text-[14px] leading-[1.5] text-[#292929]">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  /* ---- framework cards ---- */
  if (preview.type === "items") {
    return (
      <div className="space-y-4 bg-white p-4 rounded-[16px] ring-1 ring-[#E7E5E4] shadow-[0_24px_48px_-24px_rgba(16,24,40,0.25)] ">
        {preview.items.map((c) => (
          <div
            key={c.tag}
            className={`rounded-[10px] ring-1 p-4 bg-[#FAFAF9] ring-[#E7E5E4] `}
          >
            <div className="flex items-center gap-2 mb-2">
              <span
                className={`rounded-full ${toneStyles[c.tone]} px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.06em]`}
              >
                {c.tag}
              </span>

              <span className="text-[11px] text-[#A8A29E] font-medium opacity-80">
                {c.tagLabel}
              </span>
            </div>
            <p className="text-[13px] leading-[1.5] text-[#292929]">{c.text}</p>
          </div>
        ))}
      </div>
    );
  }
  /* ---- funnel / framework cards ---- */
  return (
    <div className="space-y-4 bg-white p-4 rounded-[20px]  shadow-[0_24px_48px_-24px_rgba(16,24,40,0.25)] ">
      {preview.cards.map((c) => (
        <div
          key={c.tag}
          className={`rounded-[16px] ring-1 p-4 ${
            toneStyles[c.tone] || "bg-[#FAFAF9] ring-[#EFEDEB]"
          }`}
        >
          <div className="flex items-center gap-2 mb-2">
            <span
              className={` rounded-xl ${
                badgeTone[c.tone] || "bg-white/70"
              } px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.06em]`}
            >
              {c.tag}
            </span>
          </div>
          <p className=" text-[12px] lg:text-[13px] leading-[1.5] text-[#292929]">
            {c.text}
          </p>
        </div>
      ))}
    </div>
  );
}
